export default function deepCopy<T>(toCopy: T): T {
    return JSON.parse(JSON.stringify(toCopy));
}
